import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
var DefaultStyle = {
// flex: 1,
// height: 0,
// borderTop: "1px solid var(--tea-color-border-primary)",
};
export var ListDivider = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, _b = _a.inset, inset = _b === void 0 ? "none" : _b, restProps = __rest(_a, ["children", "className", "style", "inset"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("li", __assign({ className: classNames(classPrefix + "-list__separate", className, {
            "inset-gutter": inset === "gutter",
            "inset-decorator": inset === "decorator",
        }), style: __assign(__assign({}, DefaultStyle), style), ref: ref }, restProps), children));
});
ListDivider.displayName = "ListDivider";
//# sourceMappingURL=ListDivider.js.map